import { MAP_PAYMENT_NAME_TO_ICON, PAYMENT_CONFIG } from "../paymentConstants";
import { BinIcon } from "../../../../components/icon/Icon";
import { PaymentMethodLogoStyled } from "./styled/PaymentMethodLogoStyled";
import { useMemo } from "react";

function PaymentMethodLogo(props) {
    const {paymentKey, paymentName} = props;

    const iconName = useMemo(() => paymentName
            ? MAP_PAYMENT_NAME_TO_ICON[paymentName]
            : PAYMENT_CONFIG[paymentKey]?.icon,
        [paymentKey, paymentName]);

    return <PaymentMethodLogoStyled>
        <BinIcon name={iconName || 'IcPaymentMethod'}/>
    </PaymentMethodLogoStyled>
}

export default PaymentMethodLogo;
